import { DateTime } from "./DateTime";
export var TimeRange;
(function (TimeRange) {
    function is(value) {
        return typeof value == "object" && DateTime.is(value.start) && DateTime.is(value.end);
    }
    TimeRange.is = is;
    function create(start, end) {
        return !DateTime.is(end)
            ? create(start, DateTime.next(start, end))
            : start <= end
                ? { start, end }
                : { start: end, end: start };
    }
    TimeRange.create = create;
})(TimeRange || (TimeRange = {}));
//# sourceMappingURL=TimeRange.js.map